import { HelpCircle } from "lucide-react";

// Contextual help: opens the user manual in a new tab at the given section anchor.
export default function HelpButton({ anchor, className = "" }) {
  return (
    <a
      href={`/manual/#${anchor}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`help-btn-${anchor}`}
      title="Deschide manualul la această secțiune"
      className={`inline-flex items-center justify-center h-7 w-7 rounded-full border border-slate-300 text-slate-500 hover:bg-[#FFC800] hover:text-slate-950 hover:border-[#FFC800] transition-colors ${className}`}
    >
      <HelpCircle className="h-4 w-4" />
    </a>
  );
}
